import {get, postJ} from "@/request";
import {ILoginParam,ISystemAdmin,IMenu} from "@/apis/core/types";
import {IPageRes} from "@/apis/page";

/**
 * 获取后端菜单
 */
export const getMenuApi = () => get<IMenu[]>("/admin/admin/getMenuTree")
/**
 * 获取按钮权限
 * @returns
 */
export const getPermission = () => get<string[]>("/admin/admin/gePermissions")
/**
 * 用户登录
 * @param id 用户data
 */
export const userLoginApi = (data: ILoginParam) => get("/admin/admin/login", data)
/**
 * 获取用户信息
 * @param id
 */
export const getAccountInfoApi = () => get("/admin/admin/getAccountInfo")
/**
 * 修改密码
 * @param pwd
 * @param newPwd
 * @returns
 */
export const changePassword = (pwd: string, newPwd: string) => postJ("/admin/admin/changePassword", {pwd, newPwd})
